// removed by extract-text-webpack-plugin
module.exports = {"page_pay":"app__css__app-pages-SelfHelp-payFxxy-__index__page_pay"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/SelfHelp/payFxxy/index.css
// module id = 1571
// module chunks = 0